<template>
    <b-card :title="title">
        <b-card-body>
            <slot></slot>

            <b-table :fields="fields" striped hover responsive :items="items">
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'ListItems',
    mixins: [popupMixins],
    props: ['type', 'items', 'title'],

    data() {
        return {
            query: '',
            page: 1,
            fields: [
                { key: 'id', label: 'Actions' },
                'name',
                {
                    key: 'enforced',
                    label: 'Mandatory',
                    formatter: value => (parseInt(value) ? 'True' : 'False'),
                },
                  {
                    key: 'do_release',
                    label: 'Do Release?',
                    formatter: value => (parseInt(value) ? 'True' : 'False'),
                },
                'description',
            ],
        }
    },

    mounted() {},

    methods: {},

    computed: {
        user() {
            return this.$store.state.user
        },
       
    },
}
</script>
<style></style>
